<template>
  <div class="fillContacts">
    <pendant :titleName="'Ticket buyer'"></pendant>
    <ul class="contacts-input">
      <li v-if="screenData.needContactName === 'true'">
        <label for="contactName">Name</label>
        <input maxlength="50" @input="launchEvent($event, 'needContactName')" v-model.trim="realName" type="text" id="contactName" placeholder="Fill your name here">
      </li>
      <li v-if="screenData.needContactMobile === 'true'">
        <label for="contactTelephone">Telephone</label>
        <input type="text" :maxlength="hmt ? 20 : 13" v-model.trim="mobile" @input="launchEvent($event, 'needContactMobile')" id="contactTelephone" placeholder="Please enter your phone number">
      </li>
      <li v-if="screenData.needContactEmail === 'true'">
        <label for="contactEmail">Email</label>
        <input @input="launchEvent($event, 'needContactEmail')" v-model.trim="email" type="email" maxlength="50" id="contactEmail" placeholder="Please enter your email address">
      </li>
      <li
        v-if="!(screenData.needContactHKMTPassport == 'false'
        && screenData.needContactIDCard == 'false'
        && screenData.needContactPRC == 'false'
        && screenData.needContactPassport == 'false')">
        <label for="">ID certificate type</label>
        <ul class="type-list">
          <li class="flow">
            <div
              v-if="screenData.needContactIDCard == 'true'"
              @click="cardType('contactCerType', 'id_card', 0)"
              :class="{ 'currentIndex':  currentIndex === 0}"
              class="common-item base">
              <span>ID Card</span>
              <img src="~@/assets/image/common/common_select.png" alt="">
            </div>
            <div
              v-if="screenData.needContactPassport == 'true'"
              @click="cardType('contactCerType', 'passport', 1)"
              :class="{ 'currentIndex':  currentIndex === 1}"
              class="common-item base">
              <span>Passport</span>
              <img src="~@/assets/image/common/common_select.png" alt="">
            </div>
            <div
              v-if="screenData.needContactHKMTPassport === 'true'"
              @click="cardType('contactCerType', 'hkmo_id_card', 2)"
              class="common-item"
              :class="{ 'currentIndex':  currentIndex === 2}">
              <div class="text">HK, Macao, Taiwan</div>
              <div class="text">exit-entry permit</div>
              <img src="~@/assets/image/common/common_select.png" alt="">
            </div>
            <template v-if="contacContainer > 3">
              <div
                v-for="index in contacContainer"
                :key="index"
                class="common-item hide"></div>
            </template>
            <div
              v-if="screenData.needContactPRC == 'true'"
              :class="{
                'currentIndex':  currentIndex === 3,
                'special': contacContainer === 4,
                'endControlPosition': screenData.needContactHKMTPassport == 'true' &&
                                      screenData.needContactIDCard == 'true' &&
                                      screenData.needContactPRC == 'true' &&
                                      screenData.needContactPassport == 'true'
                }"
              @click="cardType('contactCerType', 'prc', 3)"
              class="common-item">
              <div class="text">Permanent Residence </div>
              <div class="text">Permit for Foreigners</div>
              <img src="~@/assets/image/common/common_select.png" alt="">
            </div>
          </li>
        </ul>
      </li>
      <li
        v-if="!(screenData.needContactHKMTPassport == 'false'
        && screenData.needContactIDCard == 'false'
        && screenData.needContactPRC == 'false'
        && screenData.needContactPassport == 'false')">
        <label for="certificateNo">ID certificate type</label>
        <input
          v-model.trim="idCardNo"
          @input="launchEvent($event, 'contactCerNo')"
          type="text"
          :maxlength="currentMaxLength"
          id="certificateNo"
          placeholder="Please enter the ID certificate No">
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "fillContacts",
  props: {
    screenData: {
      type: Object,
      default: ()=> {},
    },
    realName: {
      type: String,
    },
    mobile: {
      type: String,
    },
    email: {
      type: String,
    },
    idCardNo: {
      type: String,
    },
    hmt: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      currentIndex: 0,
      contacContainer: 0,
      maxLengList: {
        'id_card': process.env.VUE_APP_IDCARD_MAX_LENGTH,
        'passport': process.env.VUE_APP_PASSPORT_MAX_LENGTH,
        'hkmo_id_card': process.env.VUE_APP_HKMO_IDCARD_MAX_LENGTH,
        'prc': process.env.VUE_APP_PRC_MAX_LENGTH,
      },
      currentMaxLength: process.env.VUE_APP_IDCARD_MAX_LENGTH,
    }
  },
  methods: {
    launchEvent($event, type){
      this.$emit('matchContact', {
        value: $event.target.value,
        type
      })
    },
    cardType(type, contactCerType, index){
      this.currentIndex = index;
      this.currentMaxLength = this.maxLengList[contactCerType];
      this.$emit('matchContact', {
        value: contactCerType,
        type
      });
    },
  },
  watch: {
    screenData: {
      handler(newValue){
        this.contacContainer = this.$checkFullNumber(newValue, 'contact');
      },
      immediate: true
    }
  }
};
</script>

<style scoped lang='less'>
.fillContacts{
  padding: .266667rem;
  background: #FFFFFF;
  .contacts-input{
    & > li{
      line-height: 1.333333rem;
      display: flex;
      align-items: center;
      border-bottom: 1px solid rgba(241, 242, 247, .5);
      font-size: .4rem;
      color: #000000;
      label{
        min-width: 4em;
        margin-right: .866667rem;
        display: flex;
        align-items: center;
      }
      input{
        flex: 1;
      }
      .type-list{
        flex: 1;
        .flow{
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          justify-content: space-between;
          .base{
            height: 0.986667rem;
          }
          & > div{
            padding: 0 .4rem;
            &:first-child{
              margin-left: 0;
            };
            .text{
              line-height: .5rem;
              text-align: center;
            }
          };
          .special{
              margin-top: .2rem;
          };
        };


        .common-item{
          background: #FFFFFF;
          box-shadow: 0 .053333rem .106667rem 0 rgba(0,0,0,0.06);
          border-radius: .16rem;
          border: 1px solid #BBBFD3;
          font-size: .373333rem;
          color: #333333;
          line-height: .986667rem;
          position: relative;
          img{
            display: none;
          }
        };
        .hide{
          width: 2em;
          visibility: hidden;
        }

        .currentIndex{
          position: relative;
          background: rgba(59, 109, 156, 0.07);
          border: 1px solid #3B6D9C;
          color: #3B6D9C;
          img{
            height: .346667rem;
            position: absolute;
            display: block;
            right: 0;
            bottom: 0;
          }
        }
      }
    }
  }
}
</style>
